// extracted by mini-css-extract-plugin
export var active = "_7w-a";
export var activeIndicator = "_7w-9";
export var disabled = "_7w-b";
export var fullWidth = "_7w-2";
export var lg = "_7w-7";
export var md = "_7w-6";
export var redoButtonTabGroup = "_7w-0";
export var sm = "_7w-5";
export var tabButton = "_7w-4";
export var tabButtonsContainer = "_7w-1";
export var themeDestructive = "_7w-d";
export var themeNormal = "_7w-c";
export var themeSuccess = "_7w-e";
export var xl = "_7w-8";
export var xs = "_7w-3";